import {getRequest, postRequest, postRequestFile} from "../fetchWrapper";

/**
 * Lecture de la liste des options pour les courriers après décès Express.
 *
 * @param string $token Jeton d'authentification.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getCadExpressList = (token) => {
    const url = `/api-v1/cad/express/list`
    return getRequest(url, token)
};


/**
 * Impression des courriers après décès Express.
 *
 * @param string $token Jeton d'authentification.
 * @param int $id Identifiant du défunt.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const printCadsExpress = (token, body) => {
    const url = `/api-v1/cad/express/print`
    return postRequestFile(url, body, token)
}

/**
 * Enregistrement des courriers après décès Express pour un défunt.
 *
 * @param string $token Jeton d'authentification.
 * @param object $body Corps de la requête.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const saveCadListForDeceased = (token, body) => {
    const url = `/api-v1/cad/express/save`
    return postRequest(url, body, token)
}

/**
 * Lecture de la liste des cad express pour un défunt.
 *
 * @param string $token Jeton d'authentification.
 * @param int $id Identifiant du défunt.
 * @returns Response | null Réponse de la requête à l'API.
 */
export const getCadExpressListByDeceased = (token, id) => {
    const url = `/api-v1/cad/express/deceased/${id}/list`
    return getRequest(url, token)
}